// extracted by css-extract-rspack-plugin
module.exports =  {"text":"ReEnterPasswordForm-z_jB__text","message":"ReEnterPasswordForm-MawK__message"};